import { render } from "./Attendance.vue?vue&type=template&id=bf07da00"
import script from "./Attendance.vue?vue&type=script&lang=js"
export * from "./Attendance.vue?vue&type=script&lang=js"

import exportComponent from "/home/appfloretcollegein/app.floretcollege.in/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__